export default __webpack_public_path__ + "static/media/briefcase.efcc2855.png";